import React from 'react';
import { EmptyCollection } from 'components/Account/EmptyCollection';
import { useEggContext } from 'contexts/EggContext';
import egg1 from '../../assets/img/egg/egg1.jpg';
import egg2 from '../../assets/img/egg/egg2.jpg';
import egg3 from '../../assets/img/egg/egg3.jpg';
import egg4 from '../../assets/img/egg/egg4.jpg';
import egg5 from '../../assets/img/egg/egg5.jpg';
import { hatcheningMachine } from './state-machine';
import { NoEggStep, SelectEggStep } from './SelectEgg/SelectEgg';
import { useInterpret } from '@xstate/react';
import { RevealStep } from './Reveal/Reveal';
import { HatcheningContext } from './context';
import { Link } from 'react-router-dom';
import { Button } from 'components/Button/Button';
import { routes } from 'routing/routes';
import styles from './Hatchening.module.scss';
import { FeatureFlaggedRoute } from '../FeatureFlagged/FeatureFlagged';
import { FLAGS } from '../../hooks/useFlags';
import { Egg } from '../Egg/Egg';
import { useLoginRedirect } from 'hooks/useLoginRedirect';

export function HatcheningPage() {
  const machine = useInterpret(hatcheningMachine, {
    devTools: process.env.NODE_ENV === 'development',
  });

  useLoginRedirect({ follow: routes.hatchening() });

  return (
    <HatcheningContext.Provider value={machine}>
      <NoEggStep />
      <SelectEggStep />
      <RevealStep />
    </HatcheningContext.Provider>
  );
}

export function Hatchening() {
  return (
    <Egg fullscreen={true}>
      <FeatureFlaggedRoute flag={FLAGS.hatchening} else={<HatcheningPlaceholder />}>
        <HatcheningPage />
      </FeatureFlaggedRoute>
    </Egg>
  );
}

export function HatcheningPlaceholder() {
  const { data } = useEggContext();
  const eggs = data?.eggs;

  const eggPlaceholder = [egg1, egg2, egg3, egg4, egg5];
  return (
    <div className={styles.hatcheningContainer}>
      {eggs && eggs.length === 0 ? (
        <EmptyCollection
          title="Egg Mint is live right now!"
          message="You don’t own any Eggs yet."
          placeholderImages={eggPlaceholder}
        >
          <Link className="nav-link text-center" to={routes.mint()}>
            <Button primary>Mint your egg now</Button>
          </Link>
        </EmptyCollection>
      ) : (
        <div></div>
      )}
    </div>
  );
}
